
// Loading Bar

//main-collection-wrap
paceOptions = {
  elements: {
    selectors: ['.main-collection-wrap']
  }
}


const isPLP = document.querySelector('body.template-collection')

if (isPLP) {
  // Scroll position fix imcluding for Safari:
  // Save scroll position in sessionStorage when the user scrolls
  window.addEventListener('scroll', function () {
    sessionStorage.setItem('scrollPosition', window.scrollY);
  });
  // Restore the scroll position when back button or forward button is clicked
  window.addEventListener('popstate', function () {
    if (sessionStorage.getItem('scrollPosition') !== null) {
      window.scrollTo(0, sessionStorage.getItem('scrollPosition'));
    }
  });
}

//Lazyload elements on Listing page
  const myProducts = document.querySelectorAll('.product');
  
  observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        //console.log('in the view');
        entry.target.classList.add('showed-loaded');
        entry.target.classList.remove('invisible');
        
        let imgwrap = $(entry.target).find('.image-wrap');
        let bgimg = imgwrap.attr('data-bgimg');
        imgwrap.css('background-image', 'url(' + bgimg + ')');
        
        let extraImg = $(entry.target).find('.extra-image');
        extraImg.removeClass('d-none');
        
        $('.loader-wrap').addClass('d-none');
        
        
      } else {
        //console.log('out of view');
        
      }
    });
  });

  myProducts.forEach(product => {
    observer.observe(product);
  });


// Check if .product-form__item--payment-button enters viewport, if yes, and on mobile, add class "filler-on-mobile"
// for white filler border-top to avoid text behind the image to appear on screen:

const paymentButton = document.querySelectorAll('.product-form__item--payment-button');
observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        // console.log('in the view - buttons');         
      } else {
        // console.log('out of view - buttons');
        //$('.product-single__media-group.sticky-top').removeClass('filler-on-mobile');
        
      }
  });
});
paymentButton.forEach(el => {
  observer.observe(el);
});


// Watcher for size chart element:
const sizeChart = document.querySelectorAll('.size-chart');
observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        //$('.product-single__media-group.sticky-top').addClass('filler-on-mobile');
      } 
  });
});
sizeChart.forEach(el => {
  observer.observe(el);
});




/*
$(window).on('load resize', function() {
  if ($(window).width() < 749) {
    // Change every href attribute of every a element with #
    //$('.product .product_slides  a').attr('href', 'javascript:void(0)');
    return
  }
});
*/


//Document Ready
$( document ).ready(function() {
    $('header, #PageContainer').show();
  
  /* $('.product-option-name').on('click', function(e){
    //$('.product-form__input--sizes').trigger('click');
  }) */
  
  $('.product-form__input--sizes').on('change', function () {
    $('.product-option-name').text($(this).find('option:selected').text());
});
  

  /*
  //Only show div when all inner images are loaded
  var $images = $('#Collection img');
  var loaded_images_count = 0;
  
  console.log($images.length, 'length');

  $images.on('load', function(){
      loaded_images_count++;
    
    console.log('img loaddd');
    console.log(loaded_images_count, 'increment');
    
    //Show when first 8 are loaded:
      if (loaded_images_count > 6 || $images.length <= 6) {
      //if (loaded_images_count == $images.length) {
        console.log('can show');
        $('.loader').addClass('d-none');
        $("#Collection ul.grid").removeClass('d-none');
      }
  });
  */
  
  
  
  /*
  document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages = document.querySelectorAll("img.lazy");    
    var lazyloadThrottleTimeout;

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function(img) {
              if(img.offsetTop < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('lazy');
              }
          });
          if(lazyloadImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  });
  */
  
  
  //popup close
  $('.product-popup .close-button').on('click',function(){
    $('.popup-overlay').addClass('hide');
  });
  
  
  //Mobile Search
  $('.search-mobile-prompt').on('click',function(){
      if($(this).attr('data-click-state') == 1) {
          $(this).attr('data-click-state', 0);
          $('#mobile-search').slideUp(200);
        $('.search-icon').removeClass('d-none').addClass('d-block');
            $('.search-menu .close-icon').removeClass('d-block').addClass('d-none');
      }
      else {
          $(this).attr('data-click-state', 1);
          $('#mobile-search').slideDown(200);
        $('.search-icon').removeClass('d-block').addClass('d-none');
            $('.search-menu .close-icon').removeClass('d-none').addClass('d-block');
      }
  });
  

  $('.home-menu-trigger').on('click',function(){
      if($(this).attr('data-click-state') == 1) {
          $(this).attr('data-click-state', 0);
          $('.home-nav li').removeClass('typewriter');
          $('.hamburger-menu .hamburger-icon').removeClass('d-none').addClass('d-block');
            $('.hamburger-menu .close-icon').removeClass('d-block').addClass('d-none');
      }
      else {
          $(this).attr('data-click-state', 1);
          $('.home-nav li').addClass('typewriter');
        $('.hamburger-menu .hamburger-icon').removeClass('d-block').addClass('d-none');
        $('.hamburger-menu .close-icon').removeClass('d-none').addClass('d-block');
      }
  });
  
  $('.project-focus-carousel, .store-carousel').slick({
    infinite: true,
    //prevArrow: '<button type="button" disabled class="d-none slick-prev arrow arrow--left"><</button>',
    prevArrow: '<button type="button"  class="slick-prev arrow arrow--left"><</button>',
    nextArrow: '<button type="button" class="slick-next arrow arrow--right">></button>',
    dots: true,
    responsive: [
    {
      breakpoint: 640,
      settings: {
        dots: true,
      }
    }
  	]
  });
  
  $('.recent-products').slick({
    infinite: true,
    //prevArrow: '<button type="button" disabled class="d-none slick-prev arrow arrow--left"><</button>',
    prevArrow: '<button type="button"  class="slick-prev arrow arrow--left"><</button>',
    nextArrow: '<button type="button" class="slick-next arrow arrow--right">></button>',
    slidesPerRow: 2,
    rows: 2,
    responsive: [
    {
      breakpoint: 478,
      settings: {
        infinite: false,
        slidesPerRow: 1,
        rows: 1,
      }
    }
  	]
  });

  // Adjust homepage featured project image height:
/*   function adjustHomeFeaturedProjectBannerHeight(){
    console.log('adjustHomeFeaturedProjectBannerHeigh')
    let homeProductCard = document.querySelector('#home-products li.product');
    let homeProductBlockHeight = (homeProductCard.clientHeight * 2) - 95;

    document.querySelector('.featured-project__image').style.height = homeProductBlockHeight+"px";
  }; */

  //adjust PLP grid image height:
  function adjustProductCardHeight(){
    let productCard = document.querySelector('#Collections li.product');

    if(productCard) {
      let productBlockHeight = (productCard.clientHeight * 2) - 95;
      document.querySelector('.featured-project__image').style.height = productBlockHeight+"px";
    }
  };


  $(window).on('load resize', function() {
    if ($(window).width() > 749) {
      //adjustHomeFeaturedProjectBannerHeight();
      adjustProductCardHeight();
    }
  });
  
  
  
  $('.product_slides').slick({
    infinite: true,
    prevArrow: '<button type="button"  class="slick-prev arrow arrow--left"><</i></button>',
    nextArrow: '<button type="button" class="slick-next arrow arrow--right">></i></button>',
  });
  
  
  
  // slider
  $slick_slider = $('.product-single__media-group');
  settings_slider = {
    dots: false,
    arrows: false,
    slide: '.product-single__media-wrapper',
    // more settings
  }
  slick_on_mobile( $slick_slider, settings_slider);

  // slick on mobile
    function slick_on_mobile(slider, settings){
      $(window).on('load resize', function() {
        if ($(window).width() > 749) {
          if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
          }
          return
        }
        if (!slider.hasClass('slick-initialized')) {
          $slick_slider.show();
          return slider.slick(settings);
        }
      });
    };
  
  
  
  
  
  // Fix for non-looping slider:
  /*
$('.recent-products').on('afterChange ', function(event, slick, currentSlide){
  
  if(currentSlide == 0){
    console.log('first');
  	$('.slick-prev').addClass('d-none').removeClass('d-block').attr('disabled','disabled');
    $('.slick-next').addClass('d-block').removeClass('d-none');
  } else{
  	$('.slick-prev').removeAttr('disabled');
  }
  
  if(currentSlide == slick.slideCount - 1){
    console.log('last');
  	$('.slick-next').addClass('d-none').removeClass('d-block').attr('disabled','disabled');
    $('.slick-prev').addClass('d-block').removeClass('d-none');
  } else{
  	$('.slick-next').removeAttr('disabled');
  }
});
  */
  

    // main nav
    $('#non-home-menu-trigger.hamburger-menu').on('click',function(){
        if($(this).attr('data-click-state') == 1) {
            $(this).attr('data-click-state', 0);
            $('.main-nav').slideUp();
            $('.hamburger-menu .hamburger-icon').removeClass('d-none').addClass('d-block');
            $('.hamburger-menu .close-icon').removeClass('d-block').addClass('d-none');
        }
        else {
            $(this).attr('data-click-state', 1);
            $('.main-nav').slideDown();
            $('.hamburger-menu .hamburger-icon').removeClass('d-block').addClass('d-none');
            $('.hamburger-menu .close-icon').removeClass('d-none').addClass('d-block');
        }
    });

    $('form input[type=radio]').change(function () {
        if ($("#radio-button-physical").is(":checked")) {
            $('.appt-msg--physical').addClass('d-block').removeClass('d-none');
            $('.appt-msg--video').addClass('d-none').removeClass('d-block');
        } else{
            $('.appt-msg--physical').addClass('d-none').removeClass('d-block');
            $('.appt-msg--video').addClass('d-block').removeClass('d-none');
        }
    });
  
  	// filters
	$('.filter__prompt').on('click',function(){
        if($(this).attr('data-click-state') == 1) {
            $(this).attr('data-click-state', 0);
          	$(this).removeClass('opened');
            //$(this).next('section').slideUp(200);
            $(this).next('section').hide();
        }
        else {
            $(this).attr('data-click-state', 1);
          	$(this).addClass('opened');
            //$(this).next('section').slideDown(200);
            $(this).next('section').css('display', 'inline-block');
        }
    });
  
  	$('.filter__type').on('click',function(){
        if($(this).attr('data-click-state') == 1) {
            $(this).attr('data-click-state', 0);
          	$(this).removeClass('opened');
            $(this).next('.filter__options').slideUp(200);
        }
        else {
            $(this).attr('data-click-state', 1);
          	$(this).addClass('opened');
            $(this).next('.filter__options').slideDown(200);
        }
    });

    // single product > size chart
    $('.size-prompt').on('click',function(){
        if($(this).attr('data-click-state') == 1) {
            $(this).attr('data-click-state', 0);
            $('.size-chart').slideUp(200);
          	$('.size-prompt').removeClass('opened');
        }
        else {
            $(this).attr('data-click-state', 1);
            $('.size-chart').slideDown(200);
          	$('.size-prompt').addClass('opened');
        }
    });


    



    
}); //end ready

    
  